import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from 'components/Icon';
import AnimatedNumber from 'components/AnimatedNumber';

import { capitalizeFirstLetter, onPageEditing } from 'utils';

import css from './Footer.module.scss';

const Footer = ({
    linkGroup,
    followUs,
    stock
}) => (
    <footer className={cn("footer", css.footer)} {...onPageEditing('FooterContent')}>
        <div className={css.container}>
            {linkGroup && (
                <div  className={css["slink-group"]}>
                    {linkGroup.heading && (
                        <a
                            className={css["logo-link"]}
                            href={linkGroup.headingAsLink}
                        >{linkGroup.heading}</a>
                    )}
                    <ul className={css.links}>
                        {linkGroup.linkCollection && linkGroup.linkCollection.map((link, index) => (
                            <li key={index}>
                                <a
                                    href={link.href}
                                    target={link.target}
                                    title={link.title}
                                >{link.text}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            {stock && (
                <div className={css.stock}>
                    <span>{`${stock.heading} `}</span>
                    <AnimatedNumber
                        className={css["stock-value"]}
                        visibleClassName={css["is-visible"]}
                    >
                        {stock.value.toFixed(2)}
                    </AnimatedNumber>
                    <AnimatedNumber
                        className={cn(css["stock-difference"], {
                            [css["stock-difference-positive"]]: stock.differencePercent >= 0,
                            [css["stock-difference-negative"]]: stock.differencePercent < 0
                        })}
                        visibleClassName={css["is-visible"]}
                        suffix="%"
                    >
                        {stock.differencePercent.toFixed(2)}
                    </AnimatedNumber>
                </div>
            )}
            <ul className={css.social}>
                {followUs.heading && (
                    <li className={css.followUsLabel}>{followUs.heading}</li>
                )}
                {followUs.socialLinks && followUs.socialLinks.socialLinkBlock.map((link, index) => (
                    <li key={link.blockId || index}>
                        <a
                            className={link.options.socialLinkStyle}
                            href={link.options.link}
                            target={link.options.openInNewWindow ? "_blank" : null}
                            title={capitalizeFirstLetter(link.options.socialLinkStyle)}
                        >
                            <Icon icon={link.options.socialLinkStyle} />
                            <span>{link.options.socialLinkStyle}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    </footer>
);

Footer.propTypes = {
    stock: PropTypes.shape({
        heading: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        differencePercent: PropTypes.number.isRequired,
    }),
    linkGroup: PropTypes.shape({
        heading: PropTypes.string,
        headingAsLink: PropTypes.string,
        linkCollection: PropTypes.arrayOf(PropTypes.shape({
            href: PropTypes.string.isRequired,
            language: PropTypes.string,
            target: PropTypes.string,
            text: PropTypes.string,
            title: PropTypes.string,
        }))
    }).isRequired,
    followUs: PropTypes.shape({
        heading: PropTypes.string,
        socialLinks: PropTypes.shape({
            socialLinkBlock: PropTypes.array
        })
    }).isRequired,
    followUsLabel: PropTypes.string,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx